import { createFileRoute } from '@tanstack/react-router';
import BookRoomPage from '../../../../../pages/BookRoomPage';

export const Route = createFileRoute('/_authenticated/$owner/rooms/$id/book')({
  component: BookRoomPage
});
